import { Checkbox } from '../../ui/checkbox';

const labelClass = 'block text-sm font-medium text-[#00163E] mb-1.5';
const errorClass = 'text-red-500 text-xs mt-1';

export default function StepValidacion({ data, errors, onChange }) {
  return (
    <div className="space-y-6">
      <p className="text-[#00163E]/80 text-sm leading-relaxed">
        Último paso. Antes de iniciar la validación de su perfil, necesitamos conocer sus posibles conflictos de interés y su conformidad con las condiciones de la red.
      </p>

      <div>
        <label className={labelClass}>
          Conflictos de interés <span className="text-[#8A9BB1] font-normal">(opcional)</span>
        </label>
        <textarea
          value={data.conflictos || ''}
          onChange={(e) => onChange('conflictos', e.target.value)}
          placeholder="¿Existe algún sector, empresa o tipo de organización con el que no pueda colaborar por motivos éticos, contractuales o de competencia?"
          rows={3}
          maxLength={1000}
          data-testid="adv-field-conflictos"
          className="w-full px-4 py-3 bg-white border border-[#E4E6EA] rounded text-sm text-[#00163E] placeholder:text-[#8A9BB1]/60 outline-none transition-colors duration-200 resize-none focus:border-[#C58C40]"
        />
      </div>

      {/* Referido (opcional) */}
      <div>
        <label className={labelClass}>
          ¿Cómo nos ha conocido? <span className="text-[#8A9BB1] font-normal">(opcional)</span>
        </label>
        <input
          type="text"
          value={data.referido || ''}
          onChange={(e) => onChange('referido', e.target.value)}
          placeholder="Ej: LinkedIn, recomendación de un conocido, Google..."
          data-testid="adv-field-referido"
          className="w-full px-4 py-3 bg-white border border-[#E4E6EA] rounded text-sm text-[#00163E] placeholder:text-[#8A9BB1]/60 outline-none transition-colors duration-200 focus:border-[#C58C40]"
        />
      </div>

      {/* Checkbox 1: Success Fee */}
      <div
        className={`p-5 rounded border transition-colors ${
          errors.aceptaSuccessFee ? 'border-red-400 bg-red-50/50' : 'border-[#E4E6EA] bg-[#00163E]/[0.02]'
        }`}
      >
        <div className="flex gap-4">
          <Checkbox
            id="success-fee-checkbox"
            checked={data.aceptaSuccessFee}
            onCheckedChange={(checked) => onChange('aceptaSuccessFee', checked)}
            data-testid="adv-field-success-fee"
            className="mt-0.5 border-[#00163E]/30 data-[state=checked]:bg-[#C58C40] data-[state=checked]:border-[#C58C40]"
          />
          <label htmlFor="success-fee-checkbox" className="text-sm text-[#00163E]/80 leading-relaxed cursor-pointer">
            Entiendo que Conadvy opera bajo un modelo de tarifa de éxito (Success Fee) y acepto sus condiciones.
          </label>
        </div>
        {errors.aceptaSuccessFee && <p className={`${errorClass} mt-2 ml-8`}>{errors.aceptaSuccessFee}</p>}
      </div>

      {/* Checkbox 2: Validación */}
      <div
        className={`p-5 rounded border transition-colors ${
          errors.aceptaValidacion ? 'border-red-400 bg-red-50/50' : 'border-[#E4E6EA] bg-[#00163E]/[0.02]'
        }`}
      >
        <div className="flex gap-4">
          <Checkbox
            id="validacion-checkbox"
            checked={data.aceptaValidacion}
            onCheckedChange={(checked) => onChange('aceptaValidacion', checked)}
            data-testid="adv-field-validacion"
            className="mt-0.5 border-[#00163E]/30 data-[state=checked]:bg-[#C58C40] data-[state=checked]:border-[#C58C40]"
          />
          <label htmlFor="validacion-checkbox" className="text-sm text-[#00163E]/80 leading-relaxed cursor-pointer">
            Acepto someterme al proceso de validación y selección de perfiles de Conadvy antes de ser activado en la red.
          </label>
        </div>
        {errors.aceptaValidacion && <p className={`${errorClass} mt-2 ml-8`}>{errors.aceptaValidacion}</p>}
      </div>
    </div>
  );
}
